<div class="container-fluid h-100">
  <div class="styles-body h-100">
    <div class="panel panel-default body-space">
      <div class="panel-body content-body-pages">
        <div class="user-panel">
          <div class="d-flex flex-row">
            <div class="head-buttons d-flex align-items-center gap-3">
              <app-frontend-button (click)="selectAllNodes()"
                                   [Image]="true"
                                   [class]="'card-main'"
                                   [disabled]="false"
                                   [endpoint]="ServicePath.CREATE_ROLES_PERMISSIONS"
                                   [src]="'/icons/Accept.svg'"
                                   [title]="'SelectAll'">
              </app-frontend-button>
              <app-frontend-button (click)="onAddPermissionToRole()"
                                   [Image]="true"
                                   [class]="'card-green'"
                                   [disabled]="false"
                                   [endpoint]="ServicePath.CREATE_ROLES_PERMISSIONS"
                                   [src]="'/icons/tick-square.svg'"
                                   [title]="'Submit'">
              </app-frontend-button>
            </div>
          </div>
          <mat-tree [dataSource]="dataSource"
                    [treeControl]="treeControl">
            <mat-tree-node *matTreeNodeDef="let node"
                           matTreeNodePadding
                           matTreeNodeToggle>
              <button disabled
                      mat-icon-button></button>
              <mat-checkbox (change)="addToUserPermissions(node, $event)"
                            [checked]="isUserPermission(node)"
                            class="checklist-leaf-node">{{ node.Title }}
              </mat-checkbox>
            </mat-tree-node>
            <mat-tree-node *matTreeNodeDef="let node; when: hasChild"
                           matTreeNodePadding>
              <button [attr.aria-label]="'Toggle ' + node.item"
                      class="d-flex justify-content-center align-items-center"
                      mat-icon-button
                      matTreeNodeToggle>
                <img *ngIf="!treeControl.isExpanded(node)"
                     src="/icons/arrow-left.svg">
                <img *ngIf="treeControl.isExpanded(node)"
                     src="/icons/arrow-down.svg">
              </button>
              <mat-checkbox (change)="addToUserPermissions(node, $event)"
                            [checked]="isUserPermission(node)">
                <label style="color: black"> {{ node.Title }}</label>
              </mat-checkbox>
            </mat-tree-node>
          </mat-tree>
        </div>
      </div>
    </div>
  </div>
</div>
